import React from "react";
import Batch from "../Batch";

const ResultBatches = () => {
    return <Batch status="waiting-for-result" title="Result" />;
};

export default ResultBatches;
